// extracted by mini-css-extract-plugin
export default {"pageLayout":"W-z","mainContent":"X-z","columnLayout":"Y-z","columnLayoutFill":"Z-z","columnLayoutLast":"_-z"};